import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const NikeTwillHat = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[5].productName}
				color={product.allGear[5].color}
				size={product.allGear[5].sizes}
				price={product.allGear[5].price}
				img={product.allGear[5].img}
				miniImg1={product.allGear[5].miniImg1}
				miniImg2={product.allGear[5].miniImg2}
				miniImg3={product.allGear[5].miniImg3}
			/>
		</React.Fragment>
	);
};

export default NikeTwillHat;
